import { writable } from "svelte/store";

export const myStore = writable();

export const entityStore = writable({ allCommunities: [], availableCommunities: [], steps:[] });

export const uploadProgressStore =  writable({

    data:null,
    value:0
})
